import React from 'react';
import errornotfound from '../assets/images/404.png'

const NotFound = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
           <img src={errornotfound} alt='notfound' width={300}/>
        </div>
    );
};

export default NotFound;